import React from 'react'
import { eachDayOfInterval, format, startOfWeek, parse, endOfWeek, endOfMonth, startOfMonth, subMonths, addMonths, getDate, parseISO } from 'date-fns';
import { MdCheckCircle, MdCircle, MdInfoOutline, MdMoreVert, MdOutlineCheckCircle } from 'react-icons/md';
import axios from 'axios';
import { baseUrl } from '../../assets/Animations';
import { getRequestHeaders } from '../../api';
import { createAndOrganizeTeachersCalendarEventsForDisplayedPeriodOfTime } from '../../Calendar/calendarFunctions';

const TeacherCancellationRow = ({ cancellation, cancellations, index, adminTouchCancellation, rowMenu, setRowMenu, menuRef, onMenuToggle, isOpen, setActiveMenuId, loadingAfterMenuClick }) => {
    const [displayExcuse, setDisplayExcuse] = React.useState(false);
    const [teacherCancellationInfoPopup, setTeacherCancellationInfoPopup] = React.useState(false);
    const [familyCalendarEvents, setFamilyCalendarEvents] = React.useState([]);
    const [familyCalendarEventsPopup, setFamilyCalendarEventsPopup] = React.useState(false);
    const [calendarDaysWithEvents, setCalendarDaysWithEvents] = React.useState({});

    const defineRowStyle = (cancellation, index) => {
        let styleObj = {
          backgroundColor: index % 2 === 0 ? 'rgb(248, 250, 252)' : 'rgb(255, 255, 255)',
          opacity: cancellation.excusedByAdmin ? 0.3 : 1,
        };
        return styleObj;
      }

      const findPhoto = (photoString) => {
        return photoString.startsWith('https') ? photoString : `https://app.atharo.app/images/${photoString}`
    }

    const getFamilyCalendarEvents = async (familyId, date) => {
        const allDates = eachDayOfInterval({start: startOfMonth(parse(format(subMonths(new Date(date), 1), 'MMM yyyy'), 'MMMM yyyy', new Date())), end: endOfMonth(parse(format(addMonths(new Date(date), 1), 'MMM yyyy'), 'MMMM yyyy', new Date()))});
        setFamilyCalendarEventsPopup(true);
        try {
            axios.get(`${baseUrl}/calendar/family/${familyId}`, getRequestHeaders())
            .then(res => {
                createAndOrganizeTeachersCalendarEventsForDisplayedPeriodOfTime(allDates, res.data, setCalendarDaysWithEvents);
            })
        } catch (error) {
            console.log(error);
        }
    }

    const getDatesWithEvents = (data) => {
        // Create a new object to store the dates with events
        const result = {};
      
        // Loop through the data object using Object.entries
        Object.entries(data).forEach(([date, value]) => {
          // Check if the events array is not empty
          if (value.events.length > 0) {
            result[date] = value.events;
          }
        });
      
        return result;
      }

    React.useEffect(() => {
        setFamilyCalendarEvents(getDatesWithEvents(calendarDaysWithEvents));
    }, [calendarDaysWithEvents])

    const createEllipsis = (text, length) => {
        if(!text) return
        return text.length > length ? text.substring(0, length) + '...' : text;
    }

    const tallyCancellationsBySemesterAndYear = (cancellations) => {
        const tally = {};
    
        // Iterate over each cancellation
        cancellations.forEach(cancellation => {
          if(cancellation.hiddenByAdmin) {
            return;
          } 
            const date = new Date(cancellation.dateTime);
            const month = date.getMonth() + 1; // getMonth() returns 0 for January, so +1 to match calendar months
            const year = date.getFullYear(); // Get the year
    
            let semester;
    
            // Determine which semester the month belongs to
            if (month >= 9 && month <= 12) {
                semester = 'FALL';
            } else if (month >= 1 && month <= 5) {
                semester = 'SPRING';
            } else if (month >= 6 && month <= 8) {
                semester = 'SUMMER';
            }
    
            // Create a unique key for the semester and year, e.g., 'Fall 2023'
            const key = `${semester} ${year}`;
    
            // Initialize the tally for this key if it doesn't exist, then increment it
            if (!tally[key]) {
                tally[key] = 0;
            }
            tally[key]++;
        });
    
        return tally;
    };

    const tallyCancellations = (row) => {

        let count = 0;
        let teachersCancellations = cancellations.filter(cancellation => cancellation.teacherId === row.teacherId);
        cancellations.forEach(cancellation => {
          if(cancellation.teacherId === row.teacherId) {
            count++;
          }
        })

        let semesterTally = tallyCancellationsBySemesterAndYear(teachersCancellations);
        setTeacherCancellationInfoPopup({name: row.teacherName, semesters: semesterTally});

      }

    const formatStudentName = (studentName, familyName) => {
        // Convert both names to lowercase to make the comparison case-insensitive
        const lowerStudentName = studentName.toLowerCase();
        const lowerFamilyName = familyName.toLowerCase();
        
        // Only remove familyName if it's part of the studentName, but not if studentName equals familyName
        if (lowerStudentName !== lowerFamilyName && lowerStudentName.includes(lowerFamilyName)) {
          const regex = new RegExp(`\\b${familyName}\\b`, 'i'); // Use regex to remove the family name as a word
          studentName = studentName.replace(regex, '').trim(); // Remove familyName and trim extra spaces
        }
      
        // Return the formatted name
        return `${studentName} ${familyName}`.trim();
      }

      const getFirstAndLastDateRange = (datesWithEvents) => {
        // Get the keys (dates) from the object and sort them in chronological order
        const eventDates = Object.keys(datesWithEvents).sort();
      
        if (eventDates.length === 0) {
          return ''; // Return an empty string if no dates exist
        }
      
        // Get the first and last date
        const firstDate = parseISO(eventDates[0]);
        const lastDate = parseISO(eventDates[eventDates.length - 1]);
      
        // Format the months to "MMM" (e.g., "Sept", "Nov")
        const formattedFirstMonth = format(firstDate, 'MMM');
        const formattedLastMonth = format(lastDate, 'MMM');
      
        // Return the range as a string
        return `${formattedFirstMonth} - ${formattedLastMonth}`;
      }

    return (
        <div
        className='teacher-cancellation-row'
        style={defineRowStyle(cancellation, index)}
    >
        <div className='teacher-cancellation-row__section__first'>
            <img
                className='teacher-cancellation__img'
                alt='teacher'
                src={findPhoto(cancellation.teacherImageUrl)}
            />
            {
                teacherCancellationInfoPopup && (
                    <div className='teacher-cancellation__excuse-popup'>
                        {Object.entries(teacherCancellationInfoPopup.semesters).map(([key, total]) => (
                            <div className='teacher-cancellation__excuse-popup__each-semester' key={key}>
                                {key}: {total}
                            </div>
                        ))}
                    </div>
                )
            }
            <div
                className='teacher-cancellation__teacher-name'
                onMouseEnter={() => tallyCancellations(cancellation)}
                onMouseLeave={() => setTeacherCancellationInfoPopup(false)}
            >
                {cancellation.teacherName}
            </div>
        </div>
        <div className='teacher-cancellation-row__section'>
            <div className='teacher-cancellation__teacher-date' 
                onMouseEnter={() => getFamilyCalendarEvents(cancellation.familyId, cancellation.dateTime)} 
                onMouseLeave={() => setFamilyCalendarEventsPopup(false)}
            >
                {familyCalendarEventsPopup && 
                    <div className='teacher-cancellation__teacher-calendar-popup' onMouseLeave={() => setFamilyCalendarEvents(false)}>
                        <div className='teacher-cancellation__teacher-calendar-popup__title'> {cancellation.teacherName.split(' ')[0]}'s Scheduled Lessons</div>
                        <div className='teacher-cancellation__teacher-calendar-popup__subtitle-dates'>{getFirstAndLastDateRange(familyCalendarEvents)}</div>
                        {familyCalendarEvents ?
                            Object.entries(familyCalendarEvents).map(([date, events]) => (
                                <div key={date} className='teacher-cancellation__teacher-calendar-popup__each-date'>
                                    <div className='teacher-cancellation__teacher-calendar-popup__date' >{format(parse(date, 'yyyy-MM-dd', new Date()), 'E MMM d')}:</div>
                                    <div className='teacher-cancellation__teacher-calendar-popup__each-event__wrapper'>
                                        {events.map(event => (
                                            <div key={event._id} className='teacher-cancellation__teacher-calendar-popup__each-event'>
                                                {createEllipsis(formatStudentName(event.studentName, event.familyName), 15)}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))
                        :
                        <div>Getting Calendar...</div>
                        }
                    </div>}
                {format(new Date(cancellation.dateTime), 'M/d/yy')}
            </div>
            <div className='teacher-cancellation__student-name'>
                {createEllipsis(formatStudentName(cancellation.studentName, cancellation.familyName), 26)}
            </div>
        </div>
        <div className='teacher-cancellation-row__section__last'>
            {displayExcuse && <div className='row-excuse-popup'>{cancellation.reason}</div>}
            <div className='teacher-cancellation__reason' onMouseEnter={() => cancellation.reason.length > 55 && setDisplayExcuse(cancellation)} onMouseLeave={() => setDisplayExcuse(false)}>
                {createEllipsis(cancellation.reason, 55)}
            </div>
            <div>
            {cancellation.untouchedByAdmin ? (
                <MdOutlineCheckCircle cursor={'pointer'} color='#94A3B8' size={20} onClick={() => adminTouchCancellation(cancellation._id, false, 'admin-touch')} />
            ) : (
              <MdCheckCircle cursor={'pointer'} color='#14B8A6' size={20} onClick={() => adminTouchCancellation(cancellation._id, true, 'admin-touch')} />
            
            )}
            <MdMoreVert
                color='#94A3B8'
                cursor={'pointer'}
                className='teacher-cancellation__menu-icon'
                id='teacher-cancellation-row__menu-open'
                size={20}
                onClick={() => onMenuToggle(cancellation._id)}

            />
            </div>
        </div>
        {
            <div ref={menuRef} className={`teacher-cancellation-row__menu ${isOpen ? 'open' : ''}`}>
                { loadingAfterMenuClick ?
                 <div className='teacher-cancellation-row__menu-item with-animation'>Loading...</div>
                :
                <div>
                {cancellation.excusedByAdmin ? 
                <div className='teacher-cancellation-row__menu-item' onClick={() => adminTouchCancellation(cancellation._id, false, 'excuse')}>
                    Unexcuse
                </div>
              :  
              <div className='teacher-cancellation-row__menu-item' onClick={() => adminTouchCancellation(cancellation._id, true, 'excuse')}>
              Excuse
              </div>
              }
                <div className='teacher-cancellation-row__menu-item' onClick={() => adminTouchCancellation(cancellation._id, true, 'hidden')}>
                    Remove
                </div>
            </div>
                }
                </div>
}
    </div>
    )
}
export default TeacherCancellationRow;